/**
 * This file is auto-generated from PatientProfile.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const firstName: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'First Name';
        case 'pl':
            return 'Imię';
    }
};

export const lastName: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Last Name';
        case 'pl':
            return 'Nazwisko';
    }
};

export const gender: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Gender';
        case 'pl':
            return 'Płeć';
    }
};

export const birthDate: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Birth date';
        case 'pl':
            return 'Data urodzenia';
    }
};

export const pesel: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'PESEL';
        case 'pl':
            return 'PESEL';
    }
};

export const address: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Address';
        case 'pl':
            return 'Adres';
    }
};

export const addressCountry: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Country';
        case 'pl':
            return 'Kraj';
    }
};

export const addressState: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'State';
        case 'pl':
            return 'Stan';
    }
};

export const addressCity: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'City';
        case 'pl':
            return 'Miasto';
    }
};

export const addressStreet: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Street and number';
        case 'pl':
            return 'Ulica i numer';
    }
};

export const addressPostCode: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Postal code';
        case 'pl':
            return 'Kod pocztowy';
    }
};

export const documentNumber: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Passport or identity document number';
        case 'pl':
            return 'Numer paszportu lub dokumentu tożsamości';
    }
};
